<mat-toolbar color="primary" class="toolbar">

  <!-- Left: Navigation menu button -->
  <button mat-button (click)="toggleSidenav.emit()" class="nav-button">
    <mat-icon>menu</mat-icon>
  </button>

  <!-- Center: Title with flags -->
  <div class="center-section">
    <span class="fi fi-{{flagCountryCode}} flag"></span>
    <div class="title-section">
      <div class="full-title">
        <p class="title-top">{{"HEADER.TOP_TITLE" | translate}}</p>
        <p class="title-bottom">{{"HEADER.BOTTOM_TITLE" | translate}}</p>
      </div>
      <div class="short-title">
        <p class="title-abbreviated">e-RCMS</p>
      </div>
    </div>
    <span *ngIf="!agencyEmblem" class="fi fi-{{fallbackFlagCountryCode}} flag"></span>
    <img *ngIf="agencyEmblem" [src]="agencyEmblem" alt="Agency emblem" class="flag">
  </div>

  <!-- Right: Action buttons -->
  <div class="action-buttons">
    <button mat-icon-button matTooltip="{{'HEADER.SYSTEM_STATUS' | translate}}" (click)="openSystemStatus()">
      <mat-icon *ngIf="systemStatusList" [ngStyle]="{'color': systemStatusList.statusColor}">circle</mat-icon>
    </button>

    <select #selLang (change)="switchLang(selLang.value)" class="language-select">
      <option *ngIf="translate.currentLang" disabled selected hidden>
        {{ translate.currentLang | languageCodeToName }}
      </option>
      <option *ngIf="!translate.currentLang" disabled selected hidden>
        {{ translate.getDefaultLang()| languageCodeToName }}
      </option>
      <option *ngFor="let language of translate.getLangs()" [value]="language">
        {{ language | languageCodeToName }}
      </option>
    </select>

    <button mat-icon-button [matMenuTriggerFor]="notificationMenu">
      <mat-icon>notifications_none</mat-icon>
      <span [matBadgeHidden]="notificationsCount == 0" [matBadge]="notificationsCount" matBadgeOverlap="false"
        matBadgeColor="accent"></span>
    </button>

    <button mat-icon-button [matMenuTriggerFor]="profileMenu">
      <mat-icon>perm_identity</mat-icon>
    </button>
  </div>

  <!-- Menus -->
  <mat-menu #notificationMenu="matMenu">
    <app-notification-box></app-notification-box>
  </mat-menu>

  <mat-menu #profileMenu="matMenu" class="profile-menu">
    <span *ngIf="loggedInUserName" class="user-name">{{loggedInUserName}}</span>
    <button mat-menu-item (click)="openNotificationPreferences()">
      {{"NOTIFICATION_PREFERENCES.NOTIFICATION_PREFERENCES" | translate}}
    </button>
    <button mat-menu-item (click)="changePassword()">
      {{"ACTIONS.CHANGE_PASSWORD" | translate}}
    </button>
    <button mat-menu-item (click)="logout()">
      {{"ACTIONS.LOG_OUT" | translate }}
    </button>
  </mat-menu>

</mat-toolbar>
